module.exports = __webpack_public_path__ + "assets/img/map.0e1bc18c.png";